import { render, staticRenderFns } from "./SendersSmsCreate.vue?vue&type=template&id=e8d88d60&scoped=true&"
import script from "./SendersSmsCreate.vue?vue&type=script&lang=js&"
export * from "./SendersSmsCreate.vue?vue&type=script&lang=js&"
import style0 from "./SendersSmsCreate.vue?vue&type=style&index=0&id=e8d88d60&lang=scss&scoped=true&"
import style1 from "./SendersSmsCreate.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8d88d60",
  null
  
)

export default component.exports